/**
 *      ▄ █
 *    █ █ ▀▀█  LOADBALANCER CLIENT
 *    █ ▀ ▀ █  @copyright Copyright (c) 2025
 */
import { AfterViewInit, Component, ElementRef, EventEmitter, Input, Output, ViewChild } from '@angular/core';

/* eslint-disable */
declare var Calendly: any;

/* eslint-enable */

@Component({
    selector: 'app-calendly-widget',
    template: `
        <div class="overlay">
            <img
                ngSrc="assets/shared/icons/close-cross.svg"
                id="calendly-close"
                height="20"
                width="20"
                alt="close calendly icon"
                (click)="closeWidget()"/>
            <div #container class="calendly-inline-widget" data-auto-load="false"></div>
        </div>
    `,
    styleUrls: ['./calendly-widget.component.scss']
})
export class CalendlyWidgetComponent implements AfterViewInit {
    /**
     * Grab the container to load calendly in.
     */
    @ViewChild('container') container: ElementRef;

    /**
     * Incoming user details to populate the invite section.
     */
    @Input() public userDetails: any = {};

    /**
     * Tell the parent component to hide calendly
     */
    @Output() public hideCalendly: EventEmitter<boolean> = new EventEmitter<boolean>();

    ngAfterViewInit() {
        this.triggerCalendly();
    }

    /**
     * Reset the widget and trigger close emitter.
     */
    public closeWidget(): void {
        this.hideCalendly.next(true);
    }

    /**
     * Trigger calendly iframe.
     * @private
     */
    private triggerCalendly() {
        const now = new Date();
        const year = now.getFullYear();
        const month = (now.getMonth() + 2).toString().padStart(2, '0');

        Calendly.initInlineWidget({
            url: this.getUrl(),
            parentElement: this.container.nativeElement,
            textColor: '#370065',
            primaryColor: '#54009c',
            month: `${year}-${month}`
        });
    }

    /**
     * Get url.
     * @private
     */
    private getUrl(): string {
        let parameters = '?hide_gdpr_banner=1';
        const userDetails = this.userDetails;
        if (userDetails?.name) {
            parameters = parameters + '&name=' + userDetails.name;
        }
        if (userDetails?.email) {
            parameters = parameters + '&email=' + userDetails.email;
        }

        return `https://calendly.com/loadbalancer-org/website-book-a-custom-demo${parameters}`;
    }
}
